import React from 'react'

const PageNotFound = () => (
	<div>
		<h3>Page not found</h3>
	</div>
)


export default PageNotFound
